export const endpoints = {
  cofracInvoiceComment: {
    baseRoute: 'api/CofracInvoiceComment/',
    subRoutes: { getByInvoice: 'GetByInvoice/', add: 'Add' }
  },
  associationLog: {
    baseRoute: 'api/AssociationLog/',
    subRoutes: {
      getDataChanges: 'GetDataChanges/', // {entityTypeName}/{entityId}?associationName={associationName}
      getDataChangesByLinkedEntity: 'GetDataChangesByLinkedEntity/' // {linkedEntityTypeName}/{linkedEntityId}?associationName={associationName}
    }
  },
  contactAudit: {
    baseRoute: 'api/ContactAudit/'
  },
  dossiers: {
    baseRoute: 'api/Acep/',
    subRoutes: {
      getAll: 'GetCurrentDossiers',
      getDossier: 'GetDossier/', //id
      exportExcel: 'ExportExcelCurrentDossiers',
      assignment: 'Assignment',
      getDataChanges: 'GetDataChanges/', //id/typeDossier
      getExternalAuditBatchDetails: 'GetExternalAuditBatchDetails'
    }
  },
  modelIntellisense: {
    baseRoute: 'api/model-intellisense/',
    subRoutes: {
      getEntities: 'entities',
      getEntityTree: 'entities/' // {entityName}/tree
    }
  },
  entitySchema: {
    baseRoute: 'api/EntitySchema/',
    subRoutes: {
      getProperties: 'GetProperties',
      getEntityKeys: 'GetEntityKeys', // {entityName}
      getPrimitiveProperties: 'GetPrimitiveProperties' // {entityName}
    }
  },
  ruleEngine: {
    baseRoute: 'api/RuleEngine/',
    subRoutes: {
      evaluate: 'Evaluate', //{targetEntityType}/{targetEntityId}/{ruleType}
      evaluateAll: 'EvaluateAll', //{targetEntityType}/{ruleType}
      getDefaultValue: 'GetDefaultValue', //{targetEntityType}/{targetEntityId}
      getDropDownOptionsFromPath: 'GetDropDownOptionsFromPath', //?fieldPath=
      getValidationsByRenovationProjectId: 'GetValidationsByRenovationProjectId' // {renovationProjectId}
    }
  },
  ruleFunction: {
    baseRoute: 'api/RuleFunction/',
    subRoutes: {
      getAll: 'GetAll',
      getAllActive: 'GetAllActive/' //id
    }
  },
  priorityRule: {
    baseRoute: 'api/PriorityRule/',
    subRoutes: {
      applyPriorityRules: 'ApplyPriorityRules'
    }
  },
  cofracRefacturationBatch: {
    baseRoute: 'api/CofracRefacturationBatch/',
    subRoutes: {
      delete: 'Delete/',
      getAll: 'GetAll',
      getById: 'GetById/',
      getDataChanges: 'GetDataChanges/',
      generatePdf: 'GeneratePdf/',
      downloadInvoices: 'DownloadInvoices',
      dashboard: 'Dashboard',
      eligibleOperations: 'EligibleOperations',
      create: 'Create',
      transition: 'Transition/'
    }
  },
  ruleDefinition: {
    baseRoute: 'api/RuleDefinition/',
    subRoutes: {
      getAll: 'GetAll',
      getById: 'GetById/', //id
      add: 'Add',
      update: 'Update',
      delete: 'Delete/',
      getDataChanges: 'GetDataChanges/', //id
      getAllByEntityType: 'GetAllByEntityType/', //entityType      
      getByTarget: 'GetByTarget/', //{entityType}/{entityId}
      getByTargetAndType: 'GetByTargetAndType/', //{entityType}/{entityId}/{ruleType}
      resolveOptions: 'ResolveOptions' //?fieldPath=
    }
  },
  renovationProject: {
    baseRoute: 'api/RenovationProject/',
    subRoutes: {
      getAll: 'GetAll',
      getById: 'GetById/',
      add: 'Add',
      update: 'Update',
      updateCeeProcessingStatus: 'UpdateCeeProcessingStatus/', // {id}
      getProcessingHistory: 'GetProcessingHistory/', // {id}
      getDataChanges: 'GetDataChanges/', //id
      refuseProject: 'RefuseProject/', // {id}
      getProjectStatuses: 'GetProjectStatuses/', // {renovationProjectId}           
    }
  },
  renovationProjectBeforeRenovation: {
    baseRoute: 'api/RenovationProjectBeforeRenovation/',
    subRoutes: {
      getAllAvailableForProcessing: 'GetAllAvailableForProcessing',
      getAllProcessingDone: 'GetAllProcessingDone',
      getById: 'GetDtoById/',
      update: 'Update',
      updateMultipleCeeProcessingStatus: 'UpdateMultipleCeeProcessingStatus',
      returnToProcessing: 'ReturnToProcessing/', //id
      getProcessingFormsQuestions: 'GetProcessingFormsQuestions',
      exportExcel: 'ExportExcel/'
    }
  },
  renovationProjectAfterRenovation: {
    baseRoute: 'api/RenovationProjectAfterRenovation/',
    subRoutes: {
      getAll: 'GetAll',
      getById: 'GetDtoById/'
    }
  },
  renovationProjectMessage: {
    baseRoute: 'api/RenovationProjectMessage/',
    subRoutes: {
      add: 'Add',
      getAllByRenovationProject: 'GetAllByRenovationProject/'
    }
  },
  renovationProjectFoyer: {
    baseRoute: 'api/RenovationProjectFoyer/',
    subRoutes: {
      add: 'Add',
      update: 'Update',
      delete: 'Delete',
      getR1Foyers: 'GetR1Foyers/', // {renovationProjectId}/{codeParameterType}
      getR2Foyers: 'GetR2Foyers/', // {renovationProjectId}/{taxProofParameterTypeCode}/{precarityParameterTypeCode}
      uploadTaxProofDocument: 'UploadTaxProofDocument/' // {foyerId} + multipart form 'file'
    }
  },
  renovationProjectDocument: {
    baseRoute: 'api/RenovationProjectDocument/',
    subRoutes: {
      add: 'Add',
      getAllByRenovationProject: 'GetAllByRenovationProject/',
      downloadAllDocuments: 'DownloadAllDocuments/',
      downloadAllValidDocuments: 'DownloadAllValidDocuments/',
      generateInterventionReport: 'GenerateInterventionReport/', // {renovationProjectId}/{ceeOperationId}
      setPagesValidity: 'SetPagesValidity/' // {isValid}
    }
  },
  renovationProjectDocumentPage: {
    baseRoute: 'api/RenovationProjectDocumentPage/',
    subRoutes: {
      getAllByRenovationProject: 'GetAllByRenovationProject/', // {renovationProjectId}
      update: 'Update',
      updateMultiple: 'UpdateMultiple'
    }
  },
  renovationProjectComment: {
    baseRoute: 'api/RenovationProjectComment/',
    subRoutes: {
      add: 'Add',
      uploadFiles: 'UploadFiles',
      getAllByRenovationProject: 'GetAllByRenovationProject/'
    }
  },
  renovationProjectCeeOperation: {
    baseRoute: 'api/RenovationProjectCeeOperation/',
    subRoutes: {
      getAllExternalAuditOperations: 'GetAllExternalAuditOperations/', // {renovationProjectId}
      getAllCeeOperationsByType: 'GetAllCeeOperationsByType/',
      getAllByRenovationProjectId: 'GetAllByRenovationProjectId/',
      getAllSAVCeeOperations: 'GetAllSAVCeeOperations',
      updateThirdPartyStatus: 'UpdateThirdPartyStatus',
      uploadControlOfficeReport: 'UploadControlOfficeReport/',
      getDataChanges: 'GetDataChanges/' // {id}
    }
  },
  externalAuditBatchOperation: {
    baseRoute: 'api/ExternalAuditBatchOperation/',
    subRoutes: {
      hasDovaRapportBcResponse: 'HasDovaRapportBcResponse/', // {ceeOperationId}/{externalAuditBatchId}
      markDovaProcessingFinished: 'MarkDovaProcessingFinished/' // {externalAuditBatchId}/{ceeOperationId}
    }
  },
  externalAuditBatch: {
    baseRoute: 'api/ExternalAuditBatch/',
    subRoutes: {
      add: 'Add',
      getAllByStatus: 'GetAllByStatus/',
      getById: 'GetById/',
      update: 'Update',
      delete: 'Delete/',
      deleteOperation: 'DeleteOperation/', // {batchId}/{operationId}
      updateExternalAuditBatchStatus: 'UpdateExternalAuditBatchStatus/',
      generateCommandFile: 'GenerateCommandFile/', // {batchId}
      loadReponse: 'LoadReponse/', // {batchId}
      getDataChanges: 'GetDataChanges/', // {id}
      emitBatch: 'EmitBatch', // {batchId}
      closeBatch: 'CloseBatch/', // {batchId}
      rejectOperation: 'RejectExternalAuditCeeOperation/', // {batchId}/{operationId}
      updateOperationStatus: 'UpdateBatchOperationExternalAuditStatus/', // {batchId}/{operationId}
      requestPartnerSAV: 'RequestPartnerSAV/', // {batchId}/{operationId}
      getNSInformationRequests: 'GetNSInformationRequests/', // {batchId}/{operationId}
      generateExternalAuditBatchesFile: 'GenerateExternalAuditBatchesFile',
      abandonBatch: 'AbandonBatch/', // {batchId}
      attachOperationsToBatch: 'AttachOperationsToBatch/' // {batchId}
    }
  },
  controlMonitoringComment: { baseRoute: 'api/ControlMonitoringComment' },
  controlMonitoring: {
    baseRoute: 'api/ControlMonitoring/',
    subRoutes: {
      get: 'GetControlMonitoring',
      exportExcel: 'ExportExcel',
      updateAppointment: 'UpdateAppointment/'
    }
  },
  externalAuditTempBatch: {
    baseRoute: 'api/ExternalAuditTempBatch/',
    subRoutes: {
      add: 'AddTemporaryBatch/', //actionType
      getById: 'GetById/',
      getAll: 'GetAll',
      delete: 'Delete',
      deleteOperation: 'DeleteOperation/' // {batchId}/{operationId}
    }
  },
    cofracInvoice: {
    baseRoute: 'api/CofracInvoice/',
    subRoutes: {
      getAll: 'GetAll',
      getById: 'GetById/',
      getDataChanges: 'GetDataChanges/',
      importPdfs: 'ImportPdfs',
      exportExcel: 'ExportExcel'
    }
  },
  parameterType: {
    baseRoute: 'api/ParameterType/',
    subRoutes: {
      getAll: 'GetAll',
      getById: 'GetById/',
      getByCode: 'GetByCode/',
      getAllActive: 'GetAllActive/', //id
      getAllActiveAndIsEmmyUsed: 'GetAllActiveAndIsEmmyUsed/', //id
      getAllByIsBusiness: 'GetAllByIsBusiness/', //isBusiness true or false
      getAllActiveByIsBusiness: 'GetAllActiveByIsBusiness/', //isBusiness true or false
      update: 'Update',
      add: 'Add',
      diffuse: 'Diffuse/', // id
      getDataChanges: 'GetDataChanges/', //id
      exportExcel: 'ExportExcel/' //isBusiness, title
    }
  }, 
  gridPreferences: {
    baseRoute: 'api/GridPreferences/',
    subRoutes: {
      loadPreferences: 'LoadPreferences', //idUser, page
      savePreferences: 'SavePreferences',
      deletePreferences: 'DeletePreferences',
      getUserPreferences: 'GetUserPreferences/' //idUser
    }
  },
  parameter: {
    baseRoute: 'api/Parameter/',
    subRoutes: {
      getById: 'GetById/',
      getByCodes: 'GetByCodes/', //code, codeParameterType
      getAllByType: 'GetAllByType/', //IdParameterType
      getAllActiveByType: 'GetAllActiveByType/', //idParameterType
      getAllActiveByCodeType: 'GetAllActiveByCodeType/', //CodeParameterType
      getAllActiveByNameType: 'GetAllActiveByNameType/', //NameParameterType
      getAllActiveByCodeParent: 'GetAllActiveByCodeParent/', //idParameterType, idParent
      update: 'Update',
      add: 'Add',
      diffuse: 'Diffuse/', // id
      getDataChanges: 'GetDataChanges/', //id
      transformConcatToAcepFormat: 'TransformConcatToAcepFormat/', //comb
      exportExcel: 'ExportExcel/' //idParameterType, title
    }
  },
  userProfile: {
    baseRoute: 'api/UserProfile/',
    subRoutes: {
      getAll: 'GetAll',
      getById: 'GetById/',
      add: 'Add',
      update: 'Update',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  userProfilePermission: {
    baseRoute: 'api/UserProfilePermission/',
    subRoutes: {
      getAll: 'GetAll',
      getByProfileId: 'GetByProfileId/',
      add: 'Add',
      update: 'Update',
      UpdateAccessLevel: 'UpdateAccessLevel',
      delete: 'Delete',
      getByProfiles: 'GetByProfiles'
    }
  },
  teraComponent: {
    baseRoute: 'api/TeraComponent/',
    subRoutes: {
      getAll: 'GetAll',
      add: 'Add',
      getSicaPermissionCatalog: 'GetSicaPermissionCatalog',
      syncSicaPermissions: 'SyncSicaPermissions',
      update: 'Update',
      delete: 'Delete/',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  sicaPermission: {
    baseRoute: 'api/Permission/',
    subRoutes: {
      getAllActive: 'GetAllActive',
      add: 'Add',
      update: 'Update',
      delete: 'Delete/'
    }
  },
  globalSetting: {
    baseRoute: 'api/GlobalSetting/',
    subRoutes: {
      get: 'Get',
      getAll: 'GetAll',
      add: 'Add',
      update: 'Update'
    }
  },
  actor: {
    baseRoute: 'api/Actor/',
    subRoutes: {
      getById: 'GetById/',
      getBySiret: 'GetBySiret/',
      getAll: 'GetAll',
      getAllByType: 'GetAllByType/', //actorType
      getAllActiveByType: 'GetAllActiveByType/', //actorType, id
      update: 'Update',
      add: 'Add',
      getDataChanges: 'GetDataChanges/', //id
      exportExcel: 'ExportExcel/' //actorType, title
    }
  },
  actorActivitySector: {
    baseRoute: 'api/Actor_ActivitySector/',
    subRoutes: {
      getAll: 'GetAll',
      getAllByActor: 'GetAllByActor/', //idActor
      getAvailableActivitySectorsByActor: 'GetAvailableActivitySectorsByActor/', //idActor
      add: 'Add',
      delete: 'Delete'
    }
  },
  user: {
    baseRoute: 'api/User/',
    subRoutes: {
      updatePassword: '',
      getAll: 'GetAll',
      getById: 'GetById/',
      getAllActiveByUserProfileCode: 'GetAllActiveByUserProfileCode/',
      getAllInterns: 'GetAllInterns',
      getAllByActor: 'GetAllByActor/', //idActor
      getByEmail: 'GetByEmail/',
      add: 'Add',
      update: 'Update',
      getAllowedPermissionsByUserEmail: 'GetAllowedPermissionsByUserEmail/',
      updateUserProfiles: 'updateUserProfiles',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  userUserProfile: {
    baseRoute: 'api/User_UserProfiles/',
    subRoutes: {
      getAll: 'GetAll',
      getAllByUser: 'GetAllByUserId/', //idUser
      add: 'Add',
      delete: 'Delete',
      update: 'Update',
      removeUserProfiles: 'RemoveUserProfiles'
    }
  },
  actorUserProfile: {
    baseRoute: 'api/Actor_UserProfiles/',
    subRoutes: {
      getAllByActor: 'GetAllByActorId/', //idActor
      removeActorProfiles: 'UpdateActorProfiles'
    }
  },
  designOffice: {
    baseRoute: 'api/DesignOffice/',
    subRoutes: {
      getById: 'GetById/',
      getAll: 'GetAll',
      add: 'Add',
      update: 'Update',
      getDataChanges: 'GetDataChanges/', //id
      exportExcel: 'ExportExcel'
    }
  },
  controlOffice: {
    baseRoute: 'api/ControlOffice/',
    subRoutes: {
      getById: 'GetById/',
      getAll: 'GetAll',
      getAllActiveByPartnerId: 'getAllActiveByPartnerId/', //idPartner
      add: 'Add',
      update: 'Update',
      getDataChanges: 'GetDataChanges/', //id
      exportExcel: 'ExportExcel'
    }
  },
  controlOfficePricingGrid: {
    baseRoute: 'api/ControlOffice_PricingGrid/',
    subRoutes: {
      getAllByControlOffice: 'GetAllByControlOffice/',
      getById: 'GetById/',
      add: 'Add',
      update: 'Update',
      delete: 'Delete',
      getDataChanges: 'GetDataChanges/'
    }
  },
  userTeam: {
    baseRoute: 'api/UserTeam/',
    subRoutes: {
      getById: 'GetById/',
      getAll: 'GetAll',
      add: 'Add',
      update: 'Update',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  userTeamUser: {
    baseRoute: 'api/UserTeam_User/',
    subRoutes: {
      getAll: 'GetAll',
      getAllByUserTeam: 'GetAllByUserTeam/', //idUserTeam
      getAvailableUsersByUserTeam: 'GetAvailableUsersByUserTeam/', //idUserTeam
      add: 'Add',
      delete: 'Delete'
    }
  },
  userTeamActor: {
    baseRoute: 'api/UserTeam_Actor/',
    subRoutes: {
      getAll: 'GetAll',
      getAllByUserTeam: 'GetAllByUserTeam/', //idUserTeam
      getAvailableActorsByUserTeam: 'GetAvailableActorsByUserTeam/', //idUserTeam
      add: 'Add',
      delete: 'Delete'
    }
  },
  partnerSubcontractor: {
    baseRoute: 'api/Partner_Subcontractor/',
    subRoutes: {
      getAll: 'GetAll',
      getAllBySubcontractor: 'GetAllBySubcontractor/', //idSubcontractor
      getAvailablePartnersBySubcontractor: 'GetAvailablePartnersBySubcontractor/', //idSubcontractor
      getAllByPartner: 'GetAllByPartner/', //idPartner
      getAvailableSubcontractorByPartner: 'GetAvailableSubcontractorByPartner/', //idPartner
      add: 'Add',
      delete: 'Delete'
    }
  },
  superviseurMandataire: {
    baseRoute: 'api/Superviseur_Mandataire/',
    subRoutes: {
      getAllBySuperviseur: 'GetAllBySuperviseur/', //idSuperviseur
      getAvailableMandatairesBySuperviseur: 'GetAvailableMandatairesBySuperviseur/', //idSuperviseur
      add: 'Add',
      delete: 'Delete'
    }
  },
  partnerControlOffice: {
    baseRoute: 'api/Partner_ControlOffice/',
    subRoutes: {
      getAllByControlOffice: 'GetAllByControlOffice/', //idControlOffice
      getAvailablePartnersByControlOffice: 'GetAvailablePartnersByControlOffice/', //idControlOffice
      getAllByPartner: 'GetAllByPartner/', //idPartner
      getAvailableControlOfficeByPartner: 'GetAvailableControlOfficeByPartner/', //idPartner
      add: 'Add',
      delete: 'Delete'
    }
  },
  qualificationAssignment: {
    baseRoute: 'api/QualificationAssignment/',
    subRoutes: {
      getAllByActor: 'GetAllByActor/', //idActor
      getAllByDesignOffice: 'GetAllByDesignOffice/', //idDesignOffice
      add: 'Add',
      update: 'Update',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  documentTemplate: {
    baseRoute: 'api/DocumentTemplate/',
    subRoutes: {
      getAll: 'GetAll',
      add: 'Add',
      update: 'Update',
      getDataChanges: 'GetDataChanges/', //id
      exportExcel: 'ExportExcel'
    }
  },
  renovationProjectField: {
    baseRoute: 'api/RenovationProjectField/',
    subRoutes: {
      synchronizeWithRenovationProjectModel: 'synchronizeWithRenovationProjectModel',
      updateFieldInfoFromAcep: 'updateFieldInfoFromAcep',
      getAll: 'GetAll',
      getById: 'GetById/', //id
      getByNames: 'GetByNames', //tableName, fieldName
      update: 'Update',
      getDataChanges: 'GetDataChanges/', //id
      exportExcel: 'ExportExcel'
    }
  },
  renovationProjectField_SourceDoc: {
    baseRoute: 'api/RenovationProjectField_SourceDoc/',
    subRoutes: {
      getAllByRenovationProjectField: 'GetAllByRenovationProjectField/', //idRenovationProjectField
      getAvailableSourceDocsByRenovationProjectField:
        'GetAvailableSourceDocsByRenovationProjectField/', //idRenovationProjectField
      add: 'Add',
      delete: 'Delete'
    }
  },
  processingStep: {
    baseRoute: 'api/ProcessingStep/',
    subRoutes: {
      getAll: 'GetAll',
      getAllActive: 'GetAllActive/', //id
      getById: 'GetById/', //id
      update: 'Update',
      add: 'Add',
      getDataChanges: 'GetDataChanges/', //id
      exportExcel: 'ExportExcel'
    }
  },
  processingStep_DocumentType: {
    baseRoute: 'api/ProcessingStep_DocumentType/',
    subRoutes: {
      getLinkedItems: 'GetLinkedItems/', //idProcessingStep
      getAvailableItems: 'GetAvailableItems/', //idProcessingStep
      add: 'Add',
      delete: 'Delete'
    }
  },
  processingSection: {
    baseRoute: 'api/ProcessingSection/',
    subRoutes: {
      getAllByProcessingStep: 'GetAllByProcessingStep/', // {processingStepId}
      getAllActiveByProcessingStep: 'GetAllActiveByProcessingStep/', // {processingStepId}
      getById: 'GetById/', // {id}
      add: 'Add',
      update: 'Update',
      delete: '', // {id}
      getDataChanges: 'GetDataChanges/' // {id}
    }
  },
  processingSection_RenovationProjectField: {
    baseRoute: 'api/ProcessingSection_RenovationProjectField/',
    subRoutes: {
      getAll: 'GetAll',
      getAllByProcessingSection: 'GetAllByProcessingSection/', // {idProcessingSection}
      getAvailableFieldsByProcessingSection: 'GetAvailableFieldsByProcessingSection/', // {idProcessingSection}
      getById: 'GetById/', // {id}
      add: 'Add',
      delete: '' // {id}
    }
  },
  processingSection_SpecificComponent: {
    baseRoute: 'api/ProcessingSection_SpecificComponent/',
    subRoutes: {
      getAllByProcessingSection: 'GetAllByProcessingSection/', // {idProcessingSection}
      getAvailableSpecificComponents: 'GetAvailableSpecificComponentsByProcessingSection/', // {idProcessingSection}
      getById: 'GetById/', // {id}
      add: 'Add',
      delete: 'Delete'
    }
  },
  renovationProjectProcessing: {
    baseRoute: 'api/RenovationProjectProcessing/',
    subRoutes: {
      getProcessingSteps: 'GetProcessingSteps/', // {idRenovationProject}
      getProcessingSections: 'GetProcessingSections/', // {idRenovationProject}/{idProcessingStep}
      getRenovationProjectFields: 'GetRenovationProjectFields/', // {idRenovationProject}/{idProcessingSection}
      getProcessingStepContent: 'GetProcessingStepContent/', // {idRenovationProject}/{idProcessingStep}
      update: 'Update/', // {idRenovationProject}
      getValidationAlerts: 'GetValidationAlerts/', // {idRenovationProject}
      getValidationHistory: 'GetValidationHistory/', // {idRenovationProject}
      sendPartnerInfoRequest: 'SendPartnerInfoRequest/', // {idRenovationProject}
      sendArbitrage: 'SendArbitrage/', // {idRenovationProject}
      getValidationDataChanges: 'GetValidationDataChanges', // {idRenovationProject}
      getDataChanges: 'GetDataChanges/', // {idRenovationProject}'
      setArbitrage: 'SetArbitrage/',// {idRenovationProject}
      getTagsByRenovationProjectId: 'GetTagsByRenovationProjectId/', // {idRenovationProject}
      updateTags: 'UpdateTags/',
      getProcessingRenovationProjects: 'GetProcessingRenovationProjects', 
      setInternalAuditStatus: 'SetInternalAuditStatus', 
      setAssignment: 'SetAssignment',
      setUrgency: 'SetUrgency',
      deleteUrgency: 'DeleteUrgency'
    }
  },
  ceePrecarityTable: {
    baseRoute: 'api/CeePrecarityTable/',
    subRoutes: {
      getAll: 'GetAll',
      getById: 'GetById/', //id
      add: 'Add',
      update: 'Update',
      getValues: 'GetValues/', //id
      updateValue: 'UpdateValue',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  mprPrecarityTable: {
    baseRoute: 'api/MprPrecarityTable/',
    subRoutes: {
      getAll: 'GetAll',
      getById: 'GetById/', //id
      add: 'Add',
      update: 'Update',
      getValues: 'GetValues/', //id
      updateValue: 'UpdateValue',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  ceeOperationFile: {
    baseRoute: 'api/CeeOperationFile/',
    subRoutes: {
      getAll: 'GetAll',
      getById: 'GetById/', //id
      add: 'Add',
      update: 'Update',
      duplicate: 'Duplicate',
      diffuse: 'Diffuse/', //id
      getDataChanges: 'GetDataChanges/', //id
      getOperationTypes: 'GetOperationTypes',
      exportExcel: 'ExportExcel',
      getAvaibleByTemplaiteId: 'GetAvaibleByTemplaiteId/'
    }
  },
  ceeOperationFileDistinctCase: {
    baseRoute: 'api/CeeOperationFileDistinctCase/',
    subRoutes: {
      getAllByCeeOperationFile: 'GetAllByCeeOperationFile/', //idCeeOperationFile
      getAvailableByCeeOperationFile: 'GetAvailableByCeeOperationFile/', //idCeeOperationFile
      getAllByCeeOperationFileWithParameters: 'GetAllByCeeOperationFileWithParameters/', //idCeeOperationFile
      getById: 'GetById/', //id
      add: 'Add',
      update: 'Update',
      delete: 'Delete',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  ceeOperationFileField: {
    baseRoute: 'api/CeeOperationFileField/',
    subRoutes: {
      getById: 'GetById/', //id
      getAllTermsByCeeOperationFileDistinctCase: 'GetAllTermsByCeeOperationFileDistinctCase/', //idCeeOperationFile, distinctcase
      getAllSimpleFieldsByTerm: 'GetAllSimpleFieldsByTerm/', //idTerm
      getAllFactorsByTerm: 'GetAllFactorsByTerm/', //idTerm
      getAllArgumentsByFactor: 'GetAllArgumentsByFactor/', //idFactor
      isFactorWithArgument: 'IsFactorWithArgument/', //idFactor
      add: 'Add',
      update: 'Update',
      delete: 'Delete',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  ceeOperationFileFactorValue: {
    baseRoute: 'api/CeeOperationFileFactorValue/',
    subRoutes: {
      generateRows: 'GenerateRows/', //idFactor
      getAllByFactor: 'GetAllByFactor/', //idFactor
      update: 'Update',
      delete: 'Delete',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  ceeOperationFileCss: {
    baseRoute: 'api/CeeOperationFileCss/',
    subRoutes: {
      getAllByCeeOperationFile: 'GetAllByCeeOperationFile/', //idCeeOperationFile
      getById: 'GetById/', //id
      add: 'Add',
      update: 'Update',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  ceeOperationFileCssException: {
    baseRoute: 'api/CeeOperationFileCssActorException/',
    subRoutes: {
      getByCssId: 'GetByCssId/', //idCeeOperationFileCss/{actorType} (0=Partenaire, 1=Mandataire)
      addException: 'AddException', //?cssId=&actorId=&actorType=&typeControle=
      addExceptions: 'AddExceptions', //?cssId=&actorType=&typeControle= body: guid[]
      deleteException: 'DeleteException' //?cssId=&actorId=&actorType=
    }
  },
  ceeOperationFileCpc: {
    baseRoute: 'api/CeeOperationFileCpc/',
    subRoutes: {
      getAllByCeeOperationFile: 'GetAllByCeeOperationFile/', //idCeeOperationFile
      getById: 'GetById/', //id
      add: 'Add',
      update: 'Update',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  ceeOperationFileDovaSpec: {
    baseRoute: 'api/CeeOperationFileDovaSpec/',
    subRoutes: {
      getAllByCeeOperationFile: 'GetAllByCeeOperationFile/', //idCeeOperationFile
      getAvailableByCeeOperationFile: 'GetAvailableByCeeOperationFile/', //idCeeOperationFile
      add: 'Add',
      delete: 'Delete'
    }
  },
  ceeOperationFileBalise: {
    baseRoute: 'api/CeeOperationFileBalise/',
    subRoutes: {
      getAllByCeeOperationFile: 'GetAllByCeeOperationFile/', //idCeeOperationFile
      add: 'Add',
      update: 'Update',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  ceeOperationFilePartnerQualificationType: {
    baseRoute: 'api/CeeOperationFile_PartnerQualificationType/',
    subRoutes: {
      getAllByCeeOperationFile: 'GetAllByCeeOperationFile/', //idCeeOperationFile
      getAvailableByCeeOperationFile: 'GetAvailableByCeeOperationFile/', //idCeeOperationFile
      add: 'Add',
      delete: 'Delete'
    }
  },
  ceeOperationFileDocumentType: {
    baseRoute: 'api/CeeOperationFile_DocumentType/',
    subRoutes: {
      getAllByCeeOperationFile: 'GetAllByCeeOperationFile/',
      getAvailableByCeeOperationFile: 'GetAvailableByCeeOperationFile/',
      add: 'Add',
      delete: 'Delete'
    }
  },
  ceeOperationFileDesignOfficeQualificationType: {
    baseRoute: 'api/CeeOperationFile_DesignOfficeQualificationType/',
    subRoutes: {
      getAllByCeeOperationFile: 'GetAllByCeeOperationFile/', //idCeeOperationFile
      getAvailableByCeeOperationFile: 'GetAvailableByCeeOperationFile/', //idCeeOperationFile
      add: 'Add',
      delete: 'Delete'
    }
  },
  ceeOperationFileProduct: {
    baseRoute: 'api/CeeOperationFile_Product/',
    subRoutes: {
      getAllByCeeOperationFile: 'GetAllByCeeOperationFile/', //idCeeOperationFile
      getAvailableByCeeOperationFile: 'GetAvailableByCeeOperationFile/', //idCeeOperationFile
      add: 'Add',
      delete: 'Delete'
    }
  },
  ceeOperationFileEligibilityCondition: {
    baseRoute: 'api/CeeOperationFileEligibilityCondition/',
    subRoutes: {
      getById: 'GetById/',
      getByOperationFileId: 'GetByOperationFileId/', //idOperationFile
      getAll: 'GetAll',
      add: 'Add',
      update: 'Update',
      delete: 'Delete/', //id
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  mprOperationFile: {
    baseRoute: 'api/MprOperationFile/',
    subRoutes: {
      getAll: 'GetAll',
      getById: 'GetById/', //id
      add: 'Add',
      update: 'Update',
      duplicate: 'Duplicate',
      getDataChanges: 'GetDataChanges/', //id
      exportExcel: 'ExportExcel'
    }
  },
  mprOperationFileDistinctCase: {
    baseRoute: 'api/MprOperationFileDistinctCase/',
    subRoutes: {
      getAllByMprOperationFile: 'GetAllByMprOperationFile/', //idMprOperationFile
      getAvailableByMprOperationFile: 'GetAvailableByMprOperationFile/', //idMprOperationFile
      getAllByMprOperationFileWithParameters: 'GetAllByMprOperationFileWithParameters/', //idMprOperationFile
      getById: 'GetById/', //id
      add: 'Add',
      update: 'Update',
      delete: 'Delete',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  mprOperationFileField: {
    baseRoute: 'api/MprOperationFileField/',
    subRoutes: {
      getById: 'GetById/', //id
      getAllTermsByMprOperationFileDistinctCase: 'GetAllTermsByMprOperationFileDistinctCase/', //idMprOperationFile, distinctcase
      getAllSimpleFieldsByTerm: 'GetAllSimpleFieldsByTerm/', //idTerm
      getAllFactorsByTerm: 'GetAllFactorsByTerm/', //idTerm
      getAllArgumentsByFactor: 'GetAllArgumentsByFactor/', //idFactor
      isFactorWithArgument: 'IsFactorWithArgument/', //idFactor
      add: 'Add',
      update: 'Update',
      delete: 'Delete',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  mprOperationFileFactorValue: {
    baseRoute: 'api/MprOperationFileFactorValue/',
    subRoutes: {
      generateRows: 'GenerateRows/', //idFactor
      getAllByFactor: 'GetAllByFactor/', //idFactor
      update: 'Update',
      delete: 'Delete',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  mprOperationFilePartnerQualificationType: {
    baseRoute: 'api/MprOperationFile_PartnerQualificationType/',
    subRoutes: {
      getAllByMprOperationFile: 'GetAllByMprOperationFile/', //idMprOperationFile
      getAvailableByMprOperationFile: 'GetAvailableByMprOperationFile/', //idMprOperationFile
      add: 'Add',
      delete: 'Delete'
    }
  },
  mprOperationFileProduct: {
    baseRoute: 'api/MprOperationFile_Product/',
    subRoutes: {
      getAllByMprOperationFile: 'GetAllByMprOperationFile/', //idMprOperationFile
      getAvailableByMprOperationFile: 'GetAvailableByMprOperationFile/', //idMprOperationFile
      add: 'Add',
      delete: 'Delete'
    }
  },
  mprOperationFileCeiling: {
    baseRoute: 'api/MprOperationFileCeiling/',
    subRoutes: {
      getByMprOperationFileDistinctCase: 'GetByMprOperationFileDistinctCase/', //idMprOperationFile, distinctcase
      add: 'Add',
      update: 'Update',
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  mprOperationFileEligibilityCondition: {
    baseRoute: 'api/MprOperationFileEligibilityCondition/',
    subRoutes: {
      getById: 'GetById/',
      getByOperationFileId: 'GetByOperationFileId/', //idOperationFile
      getAll: 'GetAll',
      add: 'Add',
      update: 'Update',
      delete: 'Delete/', //id
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  genericOperation: {
    baseRoute: 'api/GenericOperation/',
    subRoutes: {
      add: 'Add',
      getById: 'GetById/',
      getByIdWithDetails: 'GetByIdWithDetails/',
      update: 'Update',
      getAll: 'GetAll',
      getAllActive: 'GetAllActive',
      diffuse: 'Diffuse/', //id
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  genericProduct: {
    baseRoute: 'api/GenericProduct/',
    subRoutes: {
      add: 'Add',
      getById: 'GetById/',
      getByGenericOperationId: 'GetByGenericOperationId/', //idGenericOperation
      getCT_CTFs: 'GetCTCTFs/', //idGenericProduct
      update: 'Update',
      getAll: 'GetAll',
      getAllWithDetails: 'GetAllWithDetails',
      isAllowedChangeCT: 'IsAllowedChangeCT/', //idGenericProduct, idGenericProductCase
      isAllowedChangeCase: 'IsAllowedChangeCase/', //idGenericProduct
      getAllActive: 'GetAllActive',
      diffuse: 'Diffuse/', //id
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  genericProductCategory: {
    baseRoute: 'api/GenericProductCategory/',
    subRoutes: {
      add: 'Add',
      getById: 'GetById/',
      getByGenericProductId: 'GetByGenericProductId/', //idGenericProduct
      update: 'Update',
      updateCategoriesSelectedValues: 'UpdateCategoriesSelectedValues',
      getAll: 'GetAll',
      getAllActive: 'GetAllActive',
      delete: 'Delete/'
    }
  },
  genericProductArgument: {
    baseRoute: 'api/GenericProductArgument/',
    subRoutes: {
      add: 'Add',
      getById: 'GetById/',
      getByGenericProductIdAndCase: 'GetByGenericProductIdAndCase', //idGenericProduct, idGenericProductCase
      getByGenericProductId: 'GetByGenericProductId/', //idGenericProduct
      update: 'Update',
      getAll: 'GetAll',
      getAllActive: 'GetAllActive',
      delete: 'Delete/'
    }
  },
  genericProductCT: {
    baseRoute: 'api/GenericProductCT/',
    subRoutes: {
      add: 'Add',
      getById: 'GetById/',
      getByGenericProductId: 'GetByGenericProductId/', //idGenericProduct
      update: 'Update',
      getAll: 'GetAll',
      getAllActive: 'GetAllActive',
      delete: 'Delete/'
    }
  },
  genericProductCTF: {
    baseRoute: 'api/GenericProductCTF/',
    subRoutes: {
      add: 'Add',
      getById: 'GetById/',
      getByGenericProductId: 'GetByGenericProductId/', //idGenericProduct
      update: 'Update',
      getAll: 'GetAll',
      getAllActive: 'GetAllActive',
      delete: 'Delete/'
    }
  },
  genericProductAdditionalCTLabel: {
    baseRoute: 'api/GenericProductAdditionalCTLabel/',
    subRoutes: {
      add: 'Add',
      addRange: 'AddRange',
      getById: 'GetById/',
      getByGenericProductId: 'GetByGenericProductId/', //idGenericProduct
      update: 'Update',
      updateRange: 'UpdateRange/',
      getAll: 'GetAll',
      getAllActive: 'GetAllActive',
      delete: 'Delete/'
    }
  },
  genericOperationGenericProduct: {
    baseRoute: 'api/GenericOperation_GenericProduct/',
    subRoutes: {
      add: 'Add',
      getById: 'GetById/',
      getByGenericOperationId: 'GetByGenericOperationId/', //idGenericOperation
      getAvailableGenericProductsByGenericOperation:
        'GetAvailableGenericProductsByGenericOperation/', //idGenericOperation
      update: 'Update',
      getAll: 'GetAll',
      delete: 'Delete/'
    }
  },
  genericOperationGenericProductBaliseIn: {
    baseRoute: 'api/GenericOperation_GenericProduct_BaliseIn/',
    subRoutes: {
      add: 'Add',
      updateRange: 'UpdateRange',
      getById: 'GetById/',
      getAllByGenericOperationGenericProductId: 'GetAllByGenericOperationGenericProductId/', //idGenericOperationGenericProduct
      getMappingByGenericProductCaseId: 'GetMappingByGenericProductCaseId',
      update: 'Update',
      getAll: 'GetAll',
      delete: 'Delete/'
    }
  },
  genericOperationGenericProductBaliseOut: {
    baseRoute: 'api/GenericOperation_GenericProduct_BaliseOut/',
    subRoutes: {
      add: 'Add',
      updateRange: 'UpdateRange',
      getById: 'GetById/',
      getMappingByGenericOperationCase: 'GetMappingByGenericOperationCase',
      update: 'Update',
      getAll: 'GetAll',
      delete: 'Delete/'
    }
  },
  genericOperationCeeOperationFileFieldBaliseOut: {
    baseRoute: 'api/GenericOperation_CeeOperationFileField_BaliseOut/',
    subRoutes: {
      getMapping: 'GetMapping',
      saveMapping: 'SaveMapping'
    }
  },
  genericOperationCeeOperationFileBaliseBaliseOut: {
    baseRoute: 'api/GenericOperation_CeeOperationFileBalise_BaliseOut/',
    subRoutes: {
      getMapping: 'GetMapping',
      saveMapping: 'SaveMapping'
    }
  },
  genericOperationMprOperationFileFieldBaliseOut: {
    baseRoute: 'api/GenericOperation_MprOperationFileField_BaliseOut/',
    subRoutes: {
      getMapping: 'GetMapping',
      saveMapping: 'SaveMapping'
    }
  },
  genericOperationBaliseIn: {
    baseRoute: 'api/GenericOperationBaliseIn/',
    subRoutes: {
      add: 'Add',
      getById: 'GetById/',
      getByGenericOperationId: 'GetByGenericOperationId/', //idGenericOperation
      update: 'Update',
      getAll: 'GetAll',
      getAllActive: 'GetAllActive',
      delete: 'Delete/'
    }
  },
  genericOperationBaliseOut: {
    baseRoute: 'api/GenericOperationBaliseOut/',
    subRoutes: {
      add: 'Add',
      getById: 'GetById/',
      getByGenericOperationId: 'GetByGenericOperationId/', //idGenericOperation
      getByGenericOperationCase: 'GetByGenericOperationCase/', //idGenericOperation/GenericOperationCase
      update: 'Update',
      updateAll: 'UpdateAll',
      getAll: 'GetAll',
      getAllActive: 'GetAllActive',
      delete: 'Delete/'
    }
  },
  genericOperationCase: {
    baseRoute: 'api/GenericOperationCase/',
    subRoutes: {
      add: 'Add',
      getById: 'GetById/',
      getByGenericOperationId: 'GetByGenericOperationId/', //idGenericOperation
      getByIdWithParameters: 'GetByIdWithParameters/', //idGenericOperation
      update: 'Update',
      updateAll: 'UpdateAll',
      getAll: 'GetAll',
      getAllActive: 'GetAllActive',
      delete: 'Delete/'
    }
  },
  product: {
    baseRoute: 'api/Product/',
    subRoutes: {
      add: 'Add',
      import: 'Import',
      downloadImportTemplate: 'DownloadImportTemplate',
      getById: 'GetById/',
      getByProductId: 'GetByProductId/', //idGenericProduct
      getAvailableProduct: 'GetAvailableProduct',
      linkProduct: 'LinkProduct/', //productId, genericProductId, genericProductCaseId
      unlinkProduct: 'UnlinkProduct/', //productId
      update: 'Update',
      getAll: 'GetAll',
      getAllWithDetails: 'GetAllWithDetails',
      getProductCategories: 'GetProductCategories/',
      getByGenericProductId: 'GetByGenericProductId/', //idGenericProduct
      getDataChanges: 'GetDataChanges/' //id
    }
  },
  productCategory: {
    baseRoute: 'api/ProductCategory/',
    subRoutes: {
      add: 'Add',
      getById: 'GetById/',
      getByProductId: 'GetByProductId/', //idProduct
      update: 'Update',
      getAll: 'GetAll'
    }
  },
  productCT: {
    baseRoute: 'api/ProductCT/',
    subRoutes: {
      add: 'Add',
      getById: 'GetById/',
      getProductCTDetails: 'GetProductCTDetails/', //idProduct
      update: 'Update',
      getAll: 'GetAll'
    }
  },
  productCTFValue: {
    baseRoute: 'api/ProductCTFValue/',
    subRoutes: {
      update: 'Update/', //productId
      getById: 'GetById/', //productId
      getProductCTFDetails: 'GetProductCTFDetails/', //productId, genericProductId
      add: 'Add',
      getAll: 'GetAll'
    }
  },
  productAdditionalCT: {
    baseRoute: 'api/ProductAdditionalCT/',
    subRoutes: {
      add: 'Add',
      getByProductId: 'GetByProductId/', //idProduct
      updateRange: 'UpdateRange',
      delete: 'Delete/'
    }
  },
  identityCatalog: {
    admin: {
      controllerRoute: 'api/admin/',
      subRoutes: {
        createSicaUser: 'api/admin/create-user',
        onboardPartnerUser: 'api/admin/onboard-acep-partner',
        createTeraUser: 'api/admin/create-tera-user',
        deleteUser: 'api/admin/delete-user',
        createTenant: 'api/admin/create-tenant',
        updateTeant: 'api/admin/update-tenant',
        getRoles: 'api/admin/get-roles',
        enableDisableUser: 'api/admin/enable-disable-user',
        onboardUser: 'api/admin/onboard-user',
        resetPassword: 'api/admin/reset-password',
        enableDisableTenant: 'api/admin/enable-disable-tenant'
      }
    }
  },
  azureStorage: {
    baseRoute: 'api/AzureStorage/',
    subRoutes: {
      uploadFile: 'UploadFile',
      downloadFile: 'DownloadFile',
      checkFileExists: 'CheckFileExists',
      copyFilesFromProd: 'CopyFilesFromProd'
    }
  },
  sicaField: {
    baseRoute: 'api/SicaField/',
    subRoutes: {
      getById: 'GetById/',
      getAll: 'GetAll',
      getAvailableForRenovationProjectField: 'GetAvailableForRenovationProjectField/', //id
      update: 'Update',
      add: 'Add',
      getDataChanges: 'GetDataChanges/', //id
      exportExcel: 'ExportExcel'
    }
  },
  dovaField: {
    baseRoute: 'api/DovaField/',
    subRoutes: {
      getById: 'GetById/',
      getAll: 'GetAll',
      getOperationFileAssociations: 'GetOperationFileAssociations/',
      getComparisonFieldIds: 'GetComparisonFieldIds/',
      getAvailableForRenovationProjectField: 'GetAvailableForRenovationProjectField/', //id
      update: 'Update',
      add: 'Add',
      getDataChanges: 'GetDataChanges/', //id
      exportExcel: 'ExportExcel'
    }
  },
  dovaFieldDocumentType: {
    baseRoute: 'api/DovaField_DocumentType/',
    subRoutes: {
      getLinkedItems: 'GetLinkedItems/',
      getAvailableItems: 'GetAvailableItems/',
      add: 'Add',
      delete: 'Delete'
    }
  },
  dovaFieldUsageDova: {
    baseRoute: 'api/DovaField_UsageDova/',
    subRoutes: {
      getLinkedItems: 'GetLinkedItems/',
      getAvailableItems: 'GetAvailableItems/',
      add: 'Add',
      delete: 'Delete'
    }
  },
  dovaFieldExtractedValue: {
    baseRoute: 'api/DovaFieldExtractedValue/',
    subRoutes: {
      getById: 'GetById/',
      getAll: 'GetAll',
      getByCeeOperation: 'GetByCeeOperation/',
      getByExternalAuditBatchOperation: 'GetByExternalAuditBatchOperation/',
      getComparedValues: 'GetComparedValues/',
      getComparedValuesByExternalAuditBatchOperation:
        'GetComparedValuesByExternalAuditBatchOperation/',
      update: 'Update',
      add: 'Add',
      getDataChanges: 'GetDataChanges/', //id
      exportExcel: 'ExportExcel'
    }
  },
  cofracField: {
    baseRoute: 'api/CofracField/',
    subRoutes: {
      getById: 'GetById/',
      getAll: 'GetAll',
      // getAllActiveByIsInCommandFile: 'GetAllActiveByIsInCommandFile/',  //isInCommandFile true or false
      // getAllActiveByIsInBackFile: 'GetAllActiveByIsInBackFile/',  //isInBackFile true or false
      getAvailableForCeeOperationFileDistinctCase: 'GetAvailableForCeeOperationFileDistinctCase/', //idCeeOperationFile, id
      getAvailableCommandForCeeOperationFileField: 'GetAvailableCommandForCeeOperationFileField/', //idCeeOperationFile, distincCase, id
      getAvailableBackForCeeOperationFileField: 'GetAvailableBackForCeeOperationFileField/', //idCeeOperationFile, distincCase, id
      getAvailableForRenovationProjectField: 'GetAvailableForRenovationProjectField/', //id
      update: 'Update',
      add: 'Add',
      getDataChanges: 'GetDataChanges/', //id
      getAllCofracMainFields: 'GetAllCofracMainFields',
      getAvailableCofracMainFields: 'GetAvailableCofracMainFields/', //name
      exportExcel: 'ExportExcel'
    }
  },
  emmyField: {
    baseRoute: 'api/EmmyField/',
    subRoutes: {
      getAll: 'GetAll',
      getAvailableForCeeOperationFileDistinctCase: 'GetAvailableForCeeOperationFileDistinctCase/', //idCeeOperationFile, id
      getAvailableForCeeOperationFileField: 'GetAvailableForCeeOperationFileField/', //idCeeOperationFile, distincCase, id
      getAvailableForRenovationProjectField: 'GetAvailableForRenovationProjectField/', //id
      getDataChanges: 'GetDataChanges/', //id
      update: 'Update',
      getNewIdentifierCode: 'GetNewIdentifierCode',
      incrementPosition: 'IncrementPosition',
      decrementPosition: 'DecrementPosition',
      add: 'Add',
      exportExcel: 'ExportExcel'
    }
  },
  cofracTemplate: {
    baseRoute: 'api/CofracTemplate/',
    subRoutes: {
      getById: 'GetById/',
      getAllActiveByBatchId: 'GetAllActiveByBatchId/',
      getAll: 'GetAll',
      update: 'Update',
      add: 'Add',
      getDataChanges: 'GetDataChanges/', //id
      exportExcel: 'ExportExcel'
    }
  },
  cofracTemplate_OperationType: {
    baseRoute: 'api/CofracTemplateCeeOperationFileType/',
    subRoutes: {
      getAllByCofracTemplate: 'GetAllByCofracTemplate/',
      getAvailableByCofracTemplate: 'GetAvailableByCofracTemplate/',
      delete: 'Delete',
      add: 'Add'
    }
  },
  crmEndpoints: {
    Routes: {
      authenticationTrace: { filter: 'api/AuthenticationTrace/filter/' }
    }
  },
  ceeContractBusinessProvider: {
    baseRoute: 'api/CeeContractBusinessProvider/',
    subRoutes: {
      getById: 'GetById/',
      getAll: 'GetAll',
      getAllActive: 'GetAllActive/', //id
      getDataChanges: 'GetDataChanges/',
      update: 'Update',
      add: 'Add',
      exportExcel: 'ExportExcel'
    }
  },
  ceeContractBusinessProviderAvenant: {
    baseRoute: 'api/CeeContractBusinessProviderAvenant/',
    subRoutes: {
      getById: 'GetById/',
      getAllByContract: 'GetAllByContract/',
      getDataChanges: 'GetDataChanges/',
      update: 'Update',
      add: 'Add',
      exportExcel: 'ExportExcel'
    }
  },
  ceeContractPartner: {
    baseRoute: 'api/CeeContractPartner/',
    subRoutes: {
      getById: 'GetById/',
      getAll: 'GetAll',
      getAvailableCeeOperationFileTypesByContract: 'GetAvailableCeeOperationFileTypesByContract/', //id
      getDataChanges: 'GetDataChanges/', //id
      update: 'Update',
      addCeeOperationFileTypes: 'AddCeeOperationFileTypes/', //id
      removeCeeOperationFileTypes: 'RemoveCeeOperationFileTypes/', //id
      add: 'Add',
      exportExcel: 'ExportExcel'
    }
  },
  CeeContractPartnerAvenant: {
    baseRoute: 'api/CeeContractPartnerAvenant/',
    subRoutes: {
      getById: 'GetById/',
      getAllByContract: 'GetAllByContract/',
      getDataChanges: 'GetDataChanges/',
      update: 'Update',
      add: 'Add',
      exportExcel: 'ExportExcel'
    }
  },
  ceeContractMandataire: {
    baseRoute: 'api/CeeContractMandataire/',
    subRoutes: {
      getById: 'GetById/',
      getAll: 'GetAll',
      getAvailableCeeOperationFileTypesByContract: 'GetAvailableCeeOperationFileTypesByContract/', //id
      getDataChanges: 'GetDataChanges/',
      update: 'Update',
      addCeeOperationFileTypes: 'AddCeeOperationFileTypes/', //id
      removeCeeOperationFileTypes: 'RemoveCeeOperationFileTypes/', //id
      add: 'Add',
      exportExcel: 'ExportExcel'
    }
  },
  ceeContractMandataireAvenant: {
    baseRoute: 'api/CeeContractMandataireAvenant/',
    subRoutes: {
      getById: 'GetById/',
      getAllByContract: 'GetAllByContract/',
      getDataChanges: 'GetDataChanges/',
      update: 'Update',
      add: 'Add',
      exportExcel: 'ExportExcel'
    }
  },
  ceeContractMandataire_Partner: {
    baseRoute: 'api/CeeContractMandataire_Partner/',
    subRoutes: {
      getAllByCeeContractMandataire: 'GetAllByCeeContractMandataire/', //idCeeContractMandataire
      getAvailablePartnersByCeeContractMandataire: 'GetAvailablePartnersByCeeContractMandataire/', //idCeeContractMandataire
      add: 'Add',
      delete: 'Delete'
    }
  },
  ceeContractOblige: {
    baseRoute: 'api/CeeContractOblige/',
    subRoutes: {
      getById: 'GetById/',
      getAll: 'GetAll',
      getAllActive: 'GetAllActive/', //id
      getDataChanges: 'GetDataChanges/',
      update: 'Update',
      add: 'Add',
      exportExcel: 'ExportExcel'
    }
  },
  ceeContractObligeAvenant: {
    baseRoute: 'api/CeeContractObligeAvenant/',
    subRoutes: {
      getById: 'GetById/',
      getAllByContract: 'GetAllByContract/',
      getDataChanges: 'GetDataChanges/',
      update: 'Update',
      add: 'Add',
      exportExcel: 'ExportExcel'
    }
  },
  mprContractPartner: {
    baseRoute: 'api/MprContractPartner/',
    subRoutes: {
      getById: 'GetById/',
      getAll: 'GetAll',
      getAllActive: 'GetAllActive/', //id
      getDataChanges: 'GetDataChanges/',
      update: 'Update',
      add: 'Add',
      exportExcel: 'ExportExcel'
    }
  },
  mprContractPartnerAvenant: {
    baseRoute: 'api/MprContractPartnerAvenant/',
    subRoutes: {
      getById: 'GetById/',
      getAllByContract: 'GetAllByContract/',
      getDataChanges: 'GetDataChanges/',
      update: 'Update',
      add: 'Add',
      exportExcel: 'ExportExcel'
    }
  },
  staticListProvider: {
    baseRoute: 'api/StaticListSourceProvider/',
    subRoutes: {
      getComparators: 'GetComparators'
    }
  },
  SirenChecker: {
    baseRoute: 'api/SirenChecker/',
    subRoutes: {
      getEstablishmentsBySiren: 'GetEstablishmentsBySiren/' //+siren
    }
  }
};

